import clsx from 'clsx';

export type Stage = 'scrape' | 'parse' | 'canonicalize' | 'export' | 'verify';
export type StageState = 'pending' | 'active' | 'done' | 'error';

export interface StageNode {
  stage: Stage;
  state: StageState;
  count?: number;
}

const STAGE_LABELS: Record<Stage, string> = {
  scrape: 'Scrape',
  parse: 'Parse',
  canonicalize: 'Canonicalize',
  export: 'Export',
  verify: 'Verify',
};

const stateStyle = (state: StageState) => {
  switch (state) {
    case 'active':
      return 'border-accent-yellow bg-accent-yellow/5 text-accent-yellow animate-borderPulse';
    case 'done':
      return 'border-accent-green bg-accent-green/5 text-accent-green';
    case 'error':
      return 'border-accent-red bg-accent-red/5 text-accent-red';
    default:
      return 'border-border bg-bg-tertiary text-text-dimmed';
  }
};

export function PipelineStageView({
  stages,
  onSelect,
}: {
  stages: StageNode[];
  onSelect?: (stage: Stage) => void;
}) {
  return (
    <div className="flex items-center">
      {stages.map((s, i) => (
        <div key={s.stage} className="flex flex-1 items-center">
          <button
            type="button"
            onClick={() => onSelect?.(s.stage)}
            disabled={!onSelect}
            className={clsx(
              'flex w-full flex-col items-center rounded-md border px-3 py-2 transition-colors duration-100',
              !onSelect && 'cursor-default',
              stateStyle(s.state),
            )}
          >
            <div className="text-sm font-semibold">{STAGE_LABELS[s.stage]}</div>
            <div className="mt-0.5 font-mono text-xs tabular-nums">
              {s.count ?? 0}
            </div>
          </button>
          {i < stages.length - 1 && (
            <div
              className={clsx(
                'h-px flex-none w-6',
                s.state === 'done' ? 'bg-accent-green' : 'bg-border',
              )}
            />
          )}
        </div>
      ))}
    </div>
  );
}
